import Vue from 'vue'
import Router from 'vue-router'
import { getAtlasInfo } from '@/setup/atlasInfo'

import DemoRoutes from './demo-routes'

import courseMapRoutes from './modules/course-map'
import myLessonsRoutes from './modules/my-lessons'
import premiumLessonPlanningRoutes from './modules/premium-lesson-planning'
import manageUsersRoutes from './modules/manage-users'
import manageCoursesRoutes from './modules/manage-courses'
import communitiesRoutes from './modules/communities'

const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '../pages/Dashboard')
const MyDashboard = () => import(/* webpackChunkName: "dashboard" */ '../pages/dashboard/MyDashboard')
const MyDashboardIndex = () => import(/* webpackChunkName: "dashboard" */ '../pages/dashboard/DashboardIndex')
const MyDashboardCustomization = () => import(/* webpackChunkName: "dashboard" */ '../pages/dashboard/DashboardCustomization')
const MapsByTeacher = () => import(/* webpackChunkName: "unit" */ '../pages/unitMaps/mapsByTeacher')

// ADMIN
const AdminIndex = () => import(/* webpackChunkName: "admin" */ '../pages/admin/index')
const AdminPublicSiteSettings = () => import(/* webpackChunkName: "admin" */ '../pages/admin/publicSite/PublicSiteSettings')
const AdminPublicSiteWelcomePage = () => import(/* webpackChunkName: "admin" */ '../pages/admin/publicSite/WelcomePage')
const AdminSubjects = () => import(/* webpackChunkName: "admin" */ '../pages/admin/subjects/AdminSubjectsIndex')
const AdminGrade = () => import(/* webpackChunkName: "admin" */ '../pages/admin/grade')
const AdminMapTypes = () => import(/* webpackChunkName: "admin" */ '../pages/admin/mapTypes/AdminMapTypesIndex')
// Assessment settings
const AdminAssessments = () => import(/* webpackChunckName: "admin" */ '../pages/admin/assessments/AdminAssessmentsIndex')
// Resources Editor
const AdminResourcesEditor = () => import(/* webpackChunkName: "admin" */ '../pages/admin/communities/AdminResourcesEditor')
const oneRosterSitePrefs = () => import(/* webpackChunkName: "admin" */ '../pages/admin/oneRosterSitePrefs')
const UnitTemplateCategoryIndex = () => import(/* webpackChunkName: "admin" */ '../pages/admin/unitTemplateCategory/UnitTemplateCategoryIndex')
const UnitTemplateCategoryList = () => import(/* webpackChunkName: "admin" */ '../pages/admin/unitTemplateCategory/UnitTemplateCategoryList')
const UnitTemplateCategoryEditor = () => import(/* webpackChunkName: "admin" */ '../pages/admin/unitTemplateCategory/UnitTemplateCategoryEditor')
const UnitTemplateIndex = () => import(/* webpackChunkName: "admin" */ '../pages/admin/unitTemplate/UnitTemplateIndex')
const UnitTemplateList = () => import(/* webpackChunkName: "admin" */ '../pages/admin/unitTemplate/UnitTemplateList')
const UnitTemplateCreate = () => import(/* webpackChunkName: "admin" */ '../pages/admin/unitTemplate/UnitTemplateCreate')
const UnitTemplateEdit = () => import(/* webpackChunkName: "admin" */ '../pages/admin/unitTemplate/UnitTemplateEdit')
const AdminComplexChecklistIndex = () => import(/* webpackChunkName: "admin" */ '../pages/admin/complexChecklist/AdminComplexChecklist')
const AdminComplexChecklistMain = () => import(/* webpackChunkName: "admin" */ '../pages/admin/complexChecklist/AdminComplexChecklistMain')
const AdminComplexChecklistSettings = () => import(/* webpackChunkName: "admin" */ '../pages/admin/complexChecklist/AdminComplexChecklistSettings')
const AdminProficiencyLevels = () => import(/* webpackChunkName: "admin" */ '../pages/admin/proficiencyLevels/AdminProficiencyLevelsIndex')

// Super Admin
const SuperAdminIndex = () => import(/* webpackChunkName: "super-admin" */ '../pages/superAdmin/index')
const SuperAdminDistrict = () => import(/* webpackChunkName: "super-admin" */ '../pages/superAdmin/District')
const SuperAdminReloadUnitAttachmentTexts = () => import(/* webpackChunkName: "super-admin" */ '../pages/superAdmin/ReloadUnitAttachmentTexts')
const SuperAdminTimePeriodType = () => import(/* webpackChunkName: "super-admin" */ '../pages/superAdmin/TimePeriodType')
const SuperAdminAtlasMessage = () => import(/* webpackChunkName: "super-admin" */ '../pages/superAdmin/AtlasMessage')
const SuperAdminIdP = () => import(/* webpackChunkName: "super-admin" */ '../pages/superAdmin/idp/IdpView')
const SuperAdminTimePeriodMarker = () => import(/* webpackChunkName: "super-admin" */ '../pages/superAdmin/TimePeriodMarker')
const Schools = () => import(/* webpackChunkName: "super-admin" */ '../pages/superAdmin/Schools')
const LoginMessage = () => import(/* webpackChunkName: "super-admin" */ '../pages/superAdmin/loginMessage')
const LessonPlannerSettings = () => import(/* webpackChunkName: "super-admin" */ '../pages/superAdmin/lessonPlanningSettings/LessonPlanningSettings')
const AsyncSettings = () => import(/* webpackChunkName: "super-admin" */ '../pages/superAdmin/AsyncSettings')
const SendDataToMB = () => import(/* webpackChunckName: "super-admin" */ '../pages/superAdmin/SendDataToMB')

const SingleLesson = () => import(/* webpackChunkName: "my-lessons" */ '../pages/myLessons/LessonPlan')

const Notification = () => import(/* webpackChunkName: "notification" */ '../pages/notifications/Notification')
const PageNotFound = () => import(/* webpackChunkName: "service" */ '../pages/PageNotFound')
const ServerError = () => import(/* webpackChunkName: "service" */ '../pages/ServerError.vue')
const AccessDenied = () => import(/* webpackChunkName: "service" */ '../pages/AccessDenied')

const AdminDashboardIndex = () => import(/* webpackChunkName: "admin-dashboard" */ '../pages/admin/dashboard/AdminDashboardIndex')
const AdminMessageBoard = () => import(/* webpackChunkName: "admin-dashboard" */ '../pages/admin/messageBoard/MessageBoardIndex')
// Lesson templates
const LessonTemplates = () => import(/* webpackChunkName: "lesson-templates" */ '@/pages/admin/LessonTemplates/LessonTemplates')

// Unit
const UnitRedirect = () => import(/* webpackChunkName: "unit" */ '@/pages/unit/UnitRedirect')
const UnitPlannerIndex = () => import(/* webpackChunkName: "unit" */ '@/pages/unitPlanner/Index')
const UnitLessonsIndex = () => import(/* webpackChunkName: "unit" */ '@/pages/unit/UnitLessonsIndex.vue')
const UnitLessons = () => import(/* webpackChunkName: "unit" */ '@/pages/unit/UnitLessons.vue')
const UnitLessonsAddNewLesson = () => import(/* webpackChunkName: "unit" */ '@/pages/unit/UnitLessonsAddNewLesson.vue')
const UnitLessonsRecycleBin = () => import(/* webpackChunkName: "unit" */ '@/pages/unit/UnitLessonsRecycleBin.vue')
// const CompareUnitsIndex = () => import(/* webpackChunkName: "unit" */ '@/pages/unitPlanner/CompareUnits')
const UnitLessonSideBySideIndex = () => import(/* webpackChunkName: "unit" */ '@/pages/unitPlanner/UnitLessonSideBySideIndex')

const ComplexChecklistIndex = () => import(/* webpackChunkName: "complex-checklist" */ '@/pages/complexChecklist/ComplexChecklistIndex')
const ComplexChecklistEditor = () => import(/* webpackChunkName: "complex-checklist" */ '@/pages/complexChecklist/ComplexChecklistEditor')
const UnitStandardsIndex = () => import(/* webpackChunkName: "assessment" */ '../pages/unitStandards/UnitStandardsIndex')
const AssessmentIndex = () => import(/* webpackChunkName: "assessment" */ '../pages/assessment/AssessmentIndex')
const AssessmentEditor = () => import(/* webpackChunkName: "assessment" */ '../pages/assessment/AssessmentEditor')
const SavedReports = () => import(/* webpackChunkName: "saved-reports" */ '../pages/savedReports/SaveReportsIndex')
const Favorites = () => import(/* webpackChunkName: "favorites" */ '../pages/favorites/FavoritesIndex')
const MyCourses = () => import(/* webpackChunkName: "assessment" */ '../pages/myCourses/MyCoursesIndex')

const AllCourses = () => import(/* webpackChunkName: "browse" */ '../pages/browse/AllCoursesIndex')
const AllCoursesShare = () => import(/* webpackChunkName: "browse" */ '../pages/browse/AllCoursesShareReport')
const PrintableCourseList = () => import(/* webpackChunkName: "browse" */ '../pages/browse/PrintableCourseList')
const AdoptedStandards = () => import(/* webpackChunkName: "browse" */ '../pages/browse/AdoptedStandards')

const SavedReportIndex = () => import(/* webpackChunkName: "saved-report" */ '../pages/savedReports/singleReport/ReportIndex')
const SingleReport = () => import(/* webpackChunkName: "saved-report" */ '../pages/savedReports/singleReport/SingleReport')
const ShareReport = () => import(/* webpackChunkName: "saved-report" */ '../pages/savedReports/singleReport/ShareReport')

Vue.use(Router)
const validateIdParam = (to, from, next) => {
  if (to.params.id === undefined || Number.isInteger(+to.params.id)) next()
  else next({ name: 'PageNotFound', replace: true })
}
const routes = [
  { path: '/maps-by-teacher', name: 'MapsByTeacher', component: MapsByTeacher },
  // admin pages
  { path: '/admin', name: 'AdminIndex', component: AdminIndex },
  {
    path: '/admin/dashboard',
    name: 'AdminDashboardIndex',
    component: AdminDashboardIndex,
    redirect: { name: 'AdminIndex' }, // Page no more exists (Was deleted with My Dashboard release December 2022), but in case it was bookmarked it's not deleted but redirect is activated
    children: [
      {
        path: '*',
        redirect: {
          name: 'AdminIndex'
        }
      }
    ]
  },
  { path: '/admin/message-board', name: 'AdminMessageBoard', component: AdminMessageBoard },
  { path: '/admin/public-site/settings', name: 'AdminPublicSiteSettings', component: AdminPublicSiteSettings },
  {
    path: '/admin/public-site/welcome-page',
    name: 'AdminPublicSiteWelcomePage',
    component: AdminPublicSiteWelcomePage
  },
  { path: '/admin/subjects', name: 'AdminSubjects', component: AdminSubjects },
  { path: '/admin/grades', name: 'AdminGrade', component: AdminGrade },
  { path: '/admin/map-types', name: 'AdminMapTypes', component: AdminMapTypes },
  { path: '/admin/mapping-categories', name: 'MappingCategories', redirect: { name: 'UnitTemplateCategoryIndex' } },
  { path: '/admin/assessment-settings', name: 'AdminAssessments', component: AdminAssessments },
  { path: '/admin/assistant-template', name: 'AdminAssistantTemplate', redirect: { name: 'AdminIndex' } },
  { path: '/admin/assistant-use-template', name: 'AssistantUseTemplate', redirect: { name: 'AdminIndex' } },
  { path: '/admin/one-roster-site-prefs', name: 'oneRosterSitePrefs', component: oneRosterSitePrefs },
  { path: '/admin/lesson-templates', name: 'LessonTemplates', component: LessonTemplates },
  { path: '/admin/proficiency-levels', name: 'AdminProficiencyLevels', component: AdminProficiencyLevels },
  { path: '/admin/resources-editor', name: 'AdminResourcesEditor', component: AdminResourcesEditor },

  {
    path: '/admin/unit-template-categories',
    name: 'UnitTemplateCategoryIndex',
    component: UnitTemplateCategoryIndex,
    redirect: { name: 'UnitTemplateCategoryList' },
    children: [
      {
        path: '/',
        name: 'UnitTemplateCategoryList',
        component: UnitTemplateCategoryList
      },
      {
        path: ':id?/edit',
        name: 'UnitTemplateCategoryEditor',
        component: UnitTemplateCategoryEditor
      },
      {
        path: 'add-new',
        name: 'UnitTemplateCategoryAddNew',
        component: UnitTemplateCategoryEditor
      }
    ]
  },
  {
    path: '/admin/unit-template-editor',
    name: 'UnitTemplateIndex',
    component: UnitTemplateIndex,
    redirect: { name: 'UnitTemplateList' },
    children: [
      {
        path: '/',
        name: 'UnitTemplateList',
        component: UnitTemplateList
      },
      {
        path: 'add-new-template',
        name: 'CreateUnitTemplate',
        component: UnitTemplateCreate
      },
      {
        path: 'edit-template/:id',
        name: 'EditUnitTemplate',
        component: UnitTemplateEdit
      }
    ]
  },
  {
    path: '/admin/complex-checklist',
    name: 'AdminComplexChecklist',
    component: AdminComplexChecklistIndex,
    redirect: { name: 'AdminComplexChecklistMain' },
    children: [
      { path: '/', name: 'AdminComplexChecklistMain', component: AdminComplexChecklistMain },
      { path: 'settings', name: 'AdminComplexChecklistSettings', component: AdminComplexChecklistSettings }
    ]
  },
  /* admin: premium lesson planning */
  ...premiumLessonPlanningRoutes,
  /* admin: manage users */
  ...manageUsersRoutes,
  /* admin: manage courses */
  ...manageCoursesRoutes,

  // super-admin pages
  { path: '/super-admin', name: 'SuperAdmin', component: SuperAdminIndex },
  { path: '/super-admin/idp', name: 'SuperAdminIdp', component: SuperAdminIdP },
  { path: '/super-admin/district', name: 'District', component: SuperAdminDistrict },
  { path: '/super-admin/time-period-type', name: 'SuperAdminTimePeriodType', component: SuperAdminTimePeriodType },
  { path: '/super-admin/atlas-message', name: 'SuperAdminAtlasMessage', component: SuperAdminAtlasMessage },
  {
    path: '/super-admin/time-period-marker',
    name: 'SuperAdminTimePeriodMarker',
    component: SuperAdminTimePeriodMarker
  },
  {
    path: '/super-admin/assistant-template',
    name: 'SuperAdminAssistantTemplate',
    beforeEnter(to, from, next) {
      window.location.replace(`${window.location.origin}/Atlas/SuperAdmin/View/Default`)
    }
  },
  { path: '/super-admin/login-message', name: 'LoginMessage', component: LoginMessage },
  { path: '/super-admin/lesson-planner-settings', name: 'LessonPlannerSettings', component: LessonPlannerSettings },
  { path: '/super-admin/async-settings', name: 'AsyncSettings', component: AsyncSettings },
  { path: '/super-admin/schools', name: 'Schools', component: Schools },
  { path: '/super-admin/send-data-to-mb', name: 'SendDataToMB', component: SendDataToMB },
  {
    path: '/super-admin/reload-unit-attachment-texts',
    name: 'ReloadUnitAttachmentTexts',
    component: SuperAdminReloadUnitAttachmentTexts
  },

  // communities
  ...communitiesRoutes,

  // dashboard
  { path: '/develop/dashboard', name: 'Dashboard', component: Dashboard, redirect: { name: 'MyDashboardIndex' } }, // Page no more exists (Was deleted with My Dashboard release December 2022), but in case it was bookmarked it's not deleted but redirect is activated
  {
    path: '/develop/my-dashboard',
    name: 'MyDashboard',
    component: MyDashboard,
    redirect: { name: 'MyDashboardIndex' },
    children: [
      {
        path: '',
        name: 'MyDashboardIndex',
        component: MyDashboardIndex
      },
      {
        path: 'customization',
        name: 'MyDashboardCustomization',
        component: MyDashboardCustomization
      }
    ]
  },

  // my-lessons
  ...myLessonsRoutes,
  {
    path: '/develop/lesson/:id/view',
    alias: '/develop/lesson/:id',
    name: 'SingleLessonView',
    beforeEnter: validateIdParam,
    component: SingleLesson
  },
  // unit
  // {
  //   path: '/develop/compare-units/:firstUnitId/:secondUnitId',
  //   name: 'CompareUnits',
  //   component: CompareUnitsIndex
  // },
  // {
  //   path: '/develop/compare-units',
  //   name: 'CompareUnits',
  //   component: CompareUnitsIndex
  // },

  // unit
  // tech page-component with redirect to unit planner or unit lessons side-by-side
  {
    path: '/develop/unit/:id',
    name: 'UnitRedirect',
    component: UnitRedirect
  },
  {
    path: '/develop/side-by-side/unit/:unitId/lesson/:lessonId?',
    name: 'UnitLessonSideBySide',
    component: UnitLessonSideBySideIndex
  },
  {
    path: '/develop/unit-planner/:id',
    name: 'UnitPlannerIndex',
    beforeEnter: validateIdParam,
    component: UnitPlannerIndex
  },
  {
    path: '/develop/unit/:id/lessons',
    name: 'UnitLessonsIndex',
    beforeEnter: validateIdParam,
    component: UnitLessonsIndex,
    redirect: { name: 'UnitLessons' },
    children: [
      {
        path: '/',
        name: 'UnitLessons',
        component: UnitLessons
      },
      {
        path: 'add-new-lesson',
        name: 'UnitLessonsAddNewLesson',
        component: UnitLessonsAddNewLesson
      },
      {
        path: 'recycle-bin',
        name: 'UnitLessonsRecycleBin',
        component: UnitLessonsRecycleBin
      }
    ]
  },
  // course-map
  ...courseMapRoutes,
  // notification
  // Assessment
  {
    path: '/develop/assessment/:id?',
    name: 'AssessmentIndex',
    component: AssessmentIndex,
    redirect: { name: 'AssessmentEditor' },
    beforeEnter: validateIdParam,
    children: [
      { path: 'editor', name: 'AssessmentEditor', component: AssessmentEditor }
    ]
  },
  // Unit Standards
  {
    path: '/develop/unit-category-standards/:id',
    name: 'UnitStandardsIndex',
    component: UnitStandardsIndex,
    beforeEnter: validateIdParam
  },
  // Complex checklist
  {
    path: '/develop/complex-checklist',
    name: 'ComplexChecklistIndex',
    component: ComplexChecklistIndex,
    beforeEnter: validateIdParam,
    children: [
      { path: 'editor/:id?', name: 'ComplexChecklistEditor', component: ComplexChecklistEditor }
    ]
  },
  // My Courses
  {
    path: '/develop/my-courses',
    name: 'MyCourses',
    component: MyCourses
  },
  // Saved Reports
  {
    path: '/develop/saved-reports',
    name: 'SavedReports',
    component: SavedReports
  },
  {
    path: '/develop/saved-reports/:id',
    name: 'SavedReport',
    component: SavedReportIndex,
    redirect: { name: 'SingleReport' },
    children: [
      {
        path: '',
        name: 'SingleReport',
        component: SingleReport
      },
      {
        path: 'share',
        name: 'ShareReport',
        component: ShareReport
      }
    ]
  },
  // Favorites
  {
    path: '/develop/favorites',
    name: 'Favorites',
    component: Favorites
  },
  // All Courses
  {
    path: '/all-curriculum/all-courses',
    name: 'AllCourses',
    component: AllCourses,
    children: [
      {
        path: 'share',
        name: 'AllCoursesShare',
        component: AllCoursesShare
      }
    ]
  },
  {
    path: '/all-curriculum/printable-course-list',
    name: 'PrintableCourseList',
    component: PrintableCourseList
  },
  // Adopted Standards
  {
    path: '/all-curriculum/adopted-standards',
    name: 'AdoptedStandards',
    component: AdoptedStandards
  },

  // Google calendar
  {
    path: '/develop/google-calendar',
    name: 'GoogleCalendar',
    component: () => import(/* webpackChunkName: "google-calendar" */ '@/pages/googleCalendar/GoogleCalendarIndex')
  },
  // Support
  {
    path: '/support/your-support-team',
    name: 'YourSupportTeam',
    component: () => import(/* webpackChunkName: "support" */ '@/pages/support/YourSupportTeam')
  },
  // Notifications
  { path: '/develop/notifications', name: 'NotificationView', component: Notification },
  {
    path: '/server-error',
    name: 'ServerError',
    component: ServerError
  },
  {
    path: '/page-not-found',
    name: 'PageNotFound',
    component: PageNotFound
  },
  {
    path: '/access-denied',
    name: 'AccessDenied',
    component: AccessDenied
  },
  {
    path: '*',
    redirect: {
      name: 'PageNotFound'
    }
  }
]
if (['development', 'dev', 'local'].includes(process.env.VUE_APP_WORKING_ENV)) {
  routes.push({ ...DemoRoutes })
}
const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  base: '/',
  scrollBehavior(to) {
    return { x: 0, y: to.meta.scrollTop || 0 }
  },
  routes: routes
})
router.beforeEach(async (to, from, next) => {
  const info = await getAtlasInfo(to.fullPath)
  const deniedPath = router.resolve({ name: 'AccessDenied' }).route.fullPath
  if (to.path === '/home') {
    next('/develop/dashboard')
  }
  if (to.fullPath !== deniedPath && invalidAccess(to.path, info?.user)) {
    next({ name: 'AccessDenied', replace: true })
  }
  router.$from = from
  next()
})

/**
 *
 * @param path
 * @param user
 * @returns boolean
 */
function invalidAccess(path, user) {
  if (path.startsWith('/super-admin') && !user?.isSuperAdmin) {
    return true
  }
  if (path.startsWith('/admin/premium-lesson-planning')) {
    return !user?.isLessonManager
  }
  return path.startsWith('/admin') && !user?.isAdmin
}

export default router
